<script lang="ts" module>
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';

	export interface BlogHeader extends SbBlokData {
		email_capture: Array<ISbStoryData>;
		components: Array<ISbStoryData>;
	}
</script>

<script lang="ts">
	import Mill from '$lib/logos/mill.svelte';
	import Blok from './storyblok/blok.svelte';

	interface Props {
		data: BlogHeader;
	}

	let { data }: Props = $props();
</script>

<header
	id="site-header"
	class="fixed inset-x-0 z-50 duration-600 ease-out"
	style="top: var(--banner-height); transition-property: top"
>
	<div class="relative z-50 bg-white px-6 py-3 lg:flex lg:items-center lg:px-12 lg:py-6">
		<a href="/" title="Home"><Mill class="h-8 text-green-3" /></a>
		<div class="w-full max-lg:hidden">
			{#each data.components as component}
				<Blok content={component} />
			{/each}
		</div>
	</div>

	<div class="lg:hidden">
		{#each data.components as component}
			<Blok content={component} />
		{/each}
	</div>
</header>

{#each data.email_capture as email_capture}
	<Blok content={email_capture} />
{/each}
